/// <amd-module name="Environments/EnvironmentRunDetails/Actions/JobsActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { IEnvironmentDeploymentHistoryViewRecord, IEnvironmentRunJobRecord } from "Environments/Client/EnvironmentContracts";
import { EnvironmentStageDeploymentData } from "Environments/RemoteClients/Contracts/Traceability";

export class JobsActions extends ActionsHubBase {

    public static getKey(): string {
        return "environment-job-actions";
    }

    public initialize(instanceId?: string) {
        this._setDeploymentJobs = new Action<EnvironmentStageDeploymentData>();
    }

    public get setDeploymentJobs(): Action<EnvironmentStageDeploymentData> {
        return this._setDeploymentJobs;
    }

    private _setDeploymentJobs: Action<EnvironmentStageDeploymentData>;
}
